module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-tabs web-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/ringing_sms',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.ringing_sms')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": '/statistic/operators/sent_sms_template',
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  }), _vm._v(" " + _vm._s(_vm.$t('pages.sent_sms_template')))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a876512"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/operators/ringing/RingingTabs.vue
// module id = 561
// module chunks = 0